// import React, { useContext } from "react";
import React, { useState, useContext, useEffect } from "react";
import { Button, Card, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import "./Products.css";
import { CartContext } from "./CartContext";
// Removed websiteDetails import as it will be fetched via API
// import { websiteDetails, categories } from "./data";
import { MdLocationOn, MdCall } from "react-icons/md";
import { FaArrowLeft } from "react-icons/fa";
import API_DOMAIN from "../config/config";

const ProductDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { product } = location.state || {};
  const [productData, setProductData] = useState(product);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [companyDetails, setCompanyDetails] = useState(null);
  console.log("companyDetails:", companyDetails);

  useEffect(() => {
    const fetchProductDetailsAndCategories = async () => {
      if (!product || !productData.product_id) return;
      setLoading(true);
      setError(null);
      const payload = { fetch_all: "true" };
      try {
        const categoryRes = await fetch(`${API_DOMAIN}/category.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "listCategory" }),
        });

        const categoryData = await categoryRes.json();

        if (categoryData.head.code === 200 && categoryData.body.categories) {
          const apiCats = categoryData.body.categories.map((cat) => ({
            id: cat.category_name,
            name: cat.category_name,
          }));
          setCategories(apiCats);
        }
        const response = await fetch(`${API_DOMAIN}/product.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", action: "listProducts" }),
        });

        if (!response.ok) {
          throw new Error(
            `HTTP error fetching product details! Status: ${response.status}`,
          );
        }

        const data = await response.json();

        if (data.head.code === 200 && data.body.products) {
          const allProducts = data.body.products.map((product) => {
            const stock_control =
              product.stock_control !== undefined
                ? parseInt(product.stock_control)
                : 1;
            const stock_quantity =
              parseFloat(product.stock_quantity || product.quantity) || 0;
            const discount_control =
              product.discount_control !== undefined
                ? parseInt(product.discount_control)
                : 1;
            const discount = parseFloat(product.discount) || 0;
            const sales_rate = parseFloat(product.sales_rate) || 0;
            const sales_rate_with_discount_amount =
              parseFloat(product.sales_rate_with_discount_amount) || 0;

            let effective_price = sales_rate;
            let is_discounted = false;

            if (discount_control === 0 && discount > 0) {
              is_discounted = true;
              if (sales_rate_with_discount_amount > 0) {
                effective_price = sales_rate_with_discount_amount;
              } else {
                effective_price = sales_rate - sales_rate * (discount / 100);
              }
            }

            return {
              id: product.product_id,
              product_id: product.product_id,
              product_name: product.product_name,
              category: product.category,
              price: effective_price,
              original_price: sales_rate,
              is_discounted: is_discounted,
              sales_rate: sales_rate,
              purchase_rate: parseFloat(product.purchase_rate) || 0,
              discount_percent: discount_control === 0 ? discount : 0,
              discount_amount: sales_rate - effective_price,
              sales_rate_with_discount_amount: effective_price,
              product_mrp: parseFloat(product.product_mrp) || 0,
              discount: discount,
              discount_control: discount_control,
              stock_control: stock_control,
              stock_quantity: stock_quantity,
              product_img_url: product.product_img || "",
              unit: product.unit || "",
              barcode: product.barcode || "",
            };
          });

          const selected = allProducts.find(
            (p) => p.product_id === productData.product_id,
          );

          if (selected) {
            setProductData(selected);
          }
        } else {
          throw new Error(data.head.msg || "Failed to fetch product details.");
        }
        const companyRes = await fetch(`${API_DOMAIN}/company.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "list" }),
        });

        const companyData = await companyRes.json();
        if (
          companyData.status === 200 &&
          companyData.data &&
          companyData.data.length > 0
        ) {
          const company = companyData.data[0];
          const formattedCompany = {
            title: company.company_name,
            address: company.address || "",
            contactNumbers: [company.mobile_number].filter(Boolean),
            logo: company.company_logo_url || "",
          };
          setCompanyDetails(formattedCompany);
        } else {
          console.warn("Could not fetch company details:", companyData.msg);
          setCompanyDetails(null);
        }
      } catch (err) {
        console.error("Error in fetchProductDetailsAndCategories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetailsAndCategories();
  }, [product, productData.product_id]);

  const { cart, addToCart, increaseQty, decreaseQty, removeItem } =
    useContext(CartContext);

  // Show a loading indicator if data is still being fetched
  if (loading) {
    return (
      <div className="container productList text-white mt-5">
        Loading product details...
      </div>
    );
  }

  if (error) {
    return (
      <div className="container productList text-white mt-5">
        Error: {error}
      </div>
    );
  }

  if (!productData) {
    return (
      <div className="container productList text-white mt-5">
        Product details not found.
      </div>
    );
  }

  const cartItem = cart.find((item) => item.id === productData.id);
  const qty = cartItem ? cartItem.qty : 0;
  const isOutOfStock =
    productData.stock_control === 0 && productData.stock_quantity <= 0;

  const handleAddToCart = () => {
    if (!cartItem) {
      addToCart(productData); // Use productData from state
    }
  };

  const cartTotalItems = cart.length;
  const cartTotalPrice = cart.reduce(
    (sum, item) => sum + item.price * item.qty,
    0,
  );

  // Define seller info based on fetched data, or provide a fallback
  const sellerInfo = companyDetails || {
    title: "Seller Information Unavailable",
    address: "Please check company API endpoint.",
    contactNumbers: [],
    logo: "",
  };

  return (
    <div className="container productList text-white mt-3 ">
      <Button
        variant="primary"
        className=" w-40 px-4 py-2  fw-bold border mb-5"
        onClick={() => navigate(-1)}
      >
        <FaArrowLeft className="me-2 " />
      </Button>

      <Row>
        <Col
          lg={5}
          md={5}
          className="text-center d-flex flex-column flex-lg-row gap-6 gap-lg-5 mt-3"
        >
          {/* Thumbnail - hidden on mobile */}
          <div className="mb-2 d-none d-lg-block">
            <img
              src={productData.product_img_url}
              alt="Thumbnail"
              width="90"
              className="border rounded border-primary "
            />
          </div>

          {/* Main Image - full size on mobile, normal on desktop */}
          <div className="big-img zoom-container w-100 flex-grow-1 d-flex margin-top:-5px">
            <img
              src={productData.product_img_url}
              alt="Product"
              className="img-fluid rounded border zoom-image"
            />
          </div>
        </Col>

        <Col lg={7} md={7}>
          <h3 className="text-dark pt-3">{productData.product_name}</h3>

          {productData.is_discounted ? (
            <h5 className="text-dark mt-2">
              <span
                className="text-muted text-decoration-line-through me-2"
                style={{ fontSize: "16px" }}
              >
                ₹ {productData.original_price}
              </span>
              <span className="text-success fw-bold">
                ₹ {productData.price ? productData.price.toFixed(2) : "0.00"}
              </span>
              {productData.discount > 0 && (
                <span className="badge bg-danger ms-3">
                  {productData.discount}% OFF
                </span>
              )}
            </h5>
          ) : (
            <h5 className="text-dark mt-2 fw-bold">
              ₹ {productData.price ? productData.price.toFixed(2) : "0.00"}
            </h5>
          )}

          {isOutOfStock ? (
            <h5 className="text-danger mt-3 fw-bold">Out of Stock</h5>
          ) : qty > 0 ? (
            <div className="quantity-controls ">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  if (qty === 1) {
                    removeItem(productData.id);
                  } else {
                    decreaseQty(productData.id);
                  }
                }}
              >
                –
              </Button>

              <span className="qty-count  text-dark mx-2">{qty}</span>

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  increaseQty(productData.id);
                }}
              >
                +
              </Button>
            </div>
          ) : (
            <Button
              variant="outline-primary"
              className="mt-3 cart"
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart();
              }}
            >
              + Add to Cart
            </Button>
          )}

          <div className="mt-4">
            <Row className="d-flex justify-content-between align-items-center ">
              <Col lg="6" md={6} xs={12} className="mt-3 text-black">
                <h5>About Product:</h5>
              </Col>
            </Row>
            <Row className="d-flex justify-content-between align-items-center ">
              <Col lg="6" md={6} xs={12} className="mt-3 text-secondary">
                ITEM CODE :{" "}
                <span className="text-dark">{productData.product_code}</span>
              </Col>
              <Col lg="6" md={6} xs={12} className="mt-3 text-secondary">
                CATEGORY :{" "}
                <span className="text-dark">
                  {productData.category || "Unknown"}
                </span>
              </Col>
            </Row>
          </div>

          <div className="d-none d-lg-block">
            <Row className="mt-4  ">
              <Col lg="6" md={6} xs={12} className="mt-3 text-black">
                <h2 className="fs-6">Seller</h2>
              </Col>
            </Row>
            <Card className="p-3 mt-2">
              <Row>
                <Col md={9}>
                  <p>
                    <strong>{sellerInfo.title}</strong>
                  </p>
                  <p>
                    <FaMapMarkerAlt style={{ marginRight: "5px" }} />
                    {sellerInfo.address}
                  </p>
                  <p className="contact-box">
                    <FaPhoneAlt className="icon" />
                    {sellerInfo.contactNumbers.join(", ")}
                  </p>
                </Col>
                <Col md={3} className="text-center">
                  <img
                    src={sellerInfo.logo}
                    alt="Company Logo"
                    className="img-fluid"
                    style={{ maxWidth: "80px" }}
                  />
                </Col>
              </Row>
            </Card>
          </div>
        </Col>
      </Row>

      {cart.length > 0 && (
        <div className="cart-bar">
          <div
            className="cart-info-clickable"
            onClick={() => navigate("/orderpage")}
            style={{ cursor: "pointer" }}
          >
            <span>{cartTotalItems} ITEMS</span>
            <span className="separator"> . </span>
            <span>₹ {cartTotalPrice.toFixed(2)}</span>
          </div>
          <div className="cart-action position-relative">
            <span
              className="cart-icon"
              onClick={() => navigate("/orderpage")}
              style={{ cursor: "pointer" }}
            >
              🛒
            </span>

            {cartTotalItems > 0 && (
              <span className="cart-badge">{cartTotalItems}</span>
            )}

            <Button onClick={() => navigate("/orderpage")}>View cart</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
